import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=13bf8030&scoped=true&"
import script from "./statistics.vue?vue&type=script&lang=ts&"
export * from "./statistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf8030",
  null
  
)

export default component.exports